import { communicationService, eventsRepository } from '@ad-engine/communication';
import { InstantConfigService, targetingService } from '@ad-engine/core';
import { Injectable } from '@wikia/dependency-injection';

import { DataWarehouseTracker } from './data-warehouse';
import { LabradorTracker } from './trackers/labrador-tracker';
import { trackingUrls } from './tracking-urls';

@Injectable()
export class BaseTrackingSetup {
	constructor(
		protected labradorTracker: LabradorTracker,
		protected dwTracker: DataWarehouseTracker,
		protected instantConfig: InstantConfigService | null = null,
	) {}

	execute(): void {
		this.experimentGroupsTracker();
		this.keyValsTracker();
	}

	private experimentGroupsTracker(): void {
		const experimentsGroups = [
			...(this.instantConfig?.getActiveKeyValues() ?? []),
			...(targetingService.get('experiment_groups') || []),
		].join(';');

		if (experimentsGroups) {
			this.labradorTracker.track(experimentsGroups);
		}
		communicationService.on(eventsRepository.INTENT_IQ_GROUP_OBTAINED, ({ abTestGroup }) => {
			this.labradorTracker.track(`intentIQ_${abTestGroup}`);
		});
	}

	private keyValsTracker(): void {
		const keyVals = { ...targetingService.dump() };

		// Remove Audigent segments
		delete keyVals.AU_SEG;

		this.dwTracker.track(
			{
				keyvals: JSON.stringify(keyVals),
			},
			trackingUrls.KEY_VALS,
		);
	}
}
